
import { defineComponent, ref, PropType, computed, getCurrentInstance } from 'vue'
import { DoctorReportMarkData } from '../types'
import { DOCTOR_REPORT_MARK_INFO, DOCTOR_REPORT_MARK_INFO_4H } from '../consts'
import get from 'lodash/get'
import useRouter from '@root/src/hooks/useRouter'
import { CONNECTOR_TYPES } from '@root/src/vars/general'

export default defineComponent({
    props: {
        markData: { type: Object as PropType<DoctorReportMarkData>, required: true },
    },
    setup(props, { emit }) {
        const root = getCurrentInstance().proxy
        const { route } = useRouter(root)
        const project = computed(() => root.$store.getters.projectById(route.value.params.id))
        const GCB2Connector = computed(() => {
            return project.value?.connectors.find(
                connector => connector?.connectorType === CONNECTOR_TYPES.GCB2
            )
        })
        const is4Hands = computed(() => {
            return GCB2Connector.value?.is4H
        }) 
        const markType = computed(() => {
            const markInfo = get(
                is4Hands.value ? DOCTOR_REPORT_MARK_INFO_4H : DOCTOR_REPORT_MARK_INFO,
                props.markData.id
            )
            if (!markInfo) return 'low'
            if (parseFloat(String(props.markData.value)) >= parseFloat(markInfo.high.value)) return 'high'
            if (parseFloat(String(props.markData.value)) >= parseFloat(markInfo.medium.value)) return 'medium'
            return 'low'
        })

        const icon = computed(() => {
            if (markType.value === 'high') return '$greenGradientCheckmark'
            if (markType.value === 'medium') return '$yellowGradientWarning'
            if (markType.value === 'low') return '$redGradientLightning'
        })

        const prettifyValue = (val: string) => String(val).replaceAll('.', ',')
        return { markType, icon, prettifyValue }
    },
})
